import { useRef, useEffect, useCallback } from 'react';

function useDebouncedCallback(callback, delay) {
  var debouncedFunction = useRef(callback);
  debouncedFunction.current = callback;
  var functionTimeoutHandler = useRef(null);
  var isComponentUnmounted = useRef(false);
  useEffect(function () {
    return function () {
      isComponentUnmounted.current = true;
    };
  }, []);
  var debouncedCallback = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(functionTimeoutHandler.current);
    functionTimeoutHandler.current = window.setTimeout(function () {
      if (!isComponentUnmounted.current) {
        debouncedFunction.current.apply(debouncedFunction, args);
      }
    }, delay);
  }, [delay]);
  return debouncedCallback;
}

export { useDebouncedCallback };